export class Book {
    driver_id:number;
    startdate:string;
    enddate:string;
    stationid:number;
    share:boolean;
    codepromo:string;
    actions: Actions;
    buttons:any;
    texts:any
}

interface Actions {
    canCancel: boolean;
    canExtend: boolean;
    canUnlock: boolean;
    canStop: boolean;
    extend: IExtend;
    start: IStart;
    stop: IStop;
    add_button: IAdd_button;
    cancel: ICancel;

  }


  interface IExtend {
    id: string;
    url: any;
    header: any;
    label: string;
    confirmation_popup: string;
  }
  
  interface IStart {
    id: string;
    url: any;
    header: any;
    label: string;
    confirmation_popup: string;
  }
  
  interface IStop {
    id: string;
    url: any;
    header: any;
    label: string;
    confirmation_popup: string;
  }

  interface ICancel {
    id: string;
    url: any;
    header: any;
    label: string;
    confirmation_popup: string;
  }
  
  interface IAdd_button {
    id: string;
    url: string;
    header: IHeader[];
    label: string;
    confirmation_popup: string;
  }
  interface IHeader {
    key: string;
    value: string;
  }

export class BookResult{

    
    constructor(
        public car_name: string,
        public driver_id: [],
        public enddate: any,
        public id: number,
        public instructions: any,
        public key: string,
        public bookingSuccess: boolean,
        public message: string,
        public mode_access: number,
        public price: any,
        public startdate: any,
        public station_id: number,
        public station_name: string,
        public status: string,
        public type: number,
        public actions: {
            canCancel: boolean;
            canExtend: boolean;
            canUnlock: boolean;
            canStop: boolean;
            extend: IExtend;
            start: IStart;
            stop: IStop;
            add_button: IAdd_button;
            cancel: ICancel;
          },
        public buttons: any,
        public texts: any

    ){

    }

}

export class ExtendCalc {
    constructor(
        public initial_price: number,
        public additional_price: number,
        public final_price : number
    ) {
        
    }
}

export class ExtendConfirm {
    constructor(
        public status : string,
        public startdate : string,
        public enddate : string,
        public price : number,
        public driver_id : [],
        public key : string,
        public id : number,
        public station_name : string,
        public station_id : number,
        public type : number,
        public initial_price : number,
        public additional_price : number
    ) {
        
    }
}